module.exports = __webpack_public_path__ + "assets/adobe-experience-platform-launch.2319eead.svg";